import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./contexts/AuthContext";
import { NetworkProvider } from "./contexts/NetworkContext";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import ProtectedRoute from "./components/ProtectedRoute";
import NetworkStatus from "./components/NetworkStatus";
import PriorityPatients from "./pages/PriorityPatients";
import PatientDetail from "./pages/PatientDetail";
import Alerts from "./pages/Alerts";
import Handoff from "./pages/Handoff";
import Login from "./pages/Login";
import Header from "./components/Header";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000, // 30 seconds
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NetworkProvider>
          <WebSocketProvider>
            <BrowserRouter>
              <Toaster position="top-right" />
              <NetworkStatus />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <Header />
                      <Routes>
                        <Route path="/" element={<PriorityPatients />} />
                        <Route path="/priority" element={<PriorityPatients />} />
                        <Route path="/patient/:patientId" element={<PatientDetail />} />
                        <Route path="/alerts" element={<Alerts />} />
                        <Route path="/handoff/:id" element={<Handoff />} />
                      </Routes>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </BrowserRouter>
          </WebSocketProvider>
        </NetworkProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
